import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { LoginGate } from './components/LoginGate'
import { App } from './App'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LoginGate>
      <App />
    </LoginGate>
  </StrictMode>
)
